import { gql } from "@apollo/client";

export const rvClassesQuery = gql`
  query {
    rv_classes
  }
`;
